export const taiKhoanQuy = {
  sections: {
    list: { title: '资金账户管理' },
  },
  titles: {
    add: '添加资金账户',
    edit: '编辑资金账户',
    // P13 (code-review 5.3): title dialog confirm delete — spec AC-3 literal.
    xoaConfirm: '删除资金账户',
  },
  columns: {
    ten: '账户名称',
    loai: '类型',
    chiNhanh: '分支',
    nganHang: '银行',
    soDuBanDau: '期初余额',
    soDuHienTai: '当前余额',
    trangThai: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    thaoTac: '操作',
  },
  filter: {
    searchPlaceholder: '按名称、银行名称、账号搜索...',
    textDetailTitle: '详细筛选',
  },
  filters: {
    hintSection: '资金账户筛选',
    hintBody: '按类型、状态和分支筛选',
    chiNhanhAll: '全部分支',
    chiNhanhSearch: '搜索分支',
    chiNhanhEmpty: '暂无分支',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  filterSection: {
    loai: '类型',
    trangThai: '状态',
    tatCa: '全部',
  },
  loai: {
    TIEN_MAT: '现金资金',
    NGAN_HANG: '银行账户',
  },
  trangThai: {
    DANG_HOAT_DONG: '启用',
    NGUNG_HOAT_DONG: '停用',
  },
  actions: {
    them: '添加资金账户',
    sua: '编辑',
    xoa: '删除',
    kichHoat: '启用',
    ngungHoatDong: '停用',
    luu: '保存',
  },
  messages: {
    noData: '暂无资金账户。',
    saveSuccess: '已保存资金账户。',
    saveError: '无法保存资金账户。',
    deleteSuccess: '已删除资金账户。',
    deleteConfirm: '删除资金账户 {ten}?此操作无法撤销。',
    coPhieuThamChieu: '该账户已被凭证引用,只能停用。',
    statusChanged: '已更新资金账户状态。',
    xungDotVersion: '该资金账户已被他人修改,请重新加载。',
    soTaiKhoanTrung: '该银行账号在分支中已存在。',
    tenTrung: '该现金资金名称在分支中已存在。',
    // P14 (code-review 5.3): V-013 explicit branch — NGAN_HANG missing required info.
    nganHangThieuThongTin: '银行账户必须同时填写银行名称和账号。',
    listSummary: '共 {count} 个账户',
    loadError: '无法加载资金账户列表。',
  },
  form: {
    ten: '账户名称',
    loai: '账户类型',
    nganHangTen: '银行名称',
    nganHangSoTaiKhoan: '账号',
    nganHangChiNhanh: '银行支行',
    chiNhanh: '分支',
    soDuBanDau: '期初余额',
    dangHoatDong: '启用状态',
    soDuHienTai: '当前余额',
    dangHoatDongOn: '启用',
    dangHoatDongOff: '停用',
  },
  validation: {
    tenRequired: '账户名称为必填项',
    tenMinLength: '名称至少3个字符',
    tenMaxLength: '名称最多100个字符',
    nganHangTenRequired: '选择银行账户时必须填写银行名称',
    soTaiKhoanInvalid: '账号必须为6-20位数字',
    nganHangTenMaxLength: '银行名称最多100个字符',
    nganHangChiNhanhMaxLength: '银行支行最多100个字符',
    soDuBanDauRequired: '请输入期初余额',
    soDuBanDauInvalid: '期初余额必须为非负数',
    soDuBanDauQuaLon: '期初余额超出允许范围',
    chuaXacDinhChiNhanh: '未识别分支,请重新登录。',
    chiNhanhRequired: '请至少选择 1 个分支。',
  },
  placeholders: {
    formTitle: '输入账户名称...',
    formBody: '',
    soDuBanDau: '0',
    nganHangSoTaiKhoan: '输入6-20位数字',
  },
  detailTabs: {
    phieuThu: '收款单',
    phieuChi: '付款单',
  },
  expand: {
    rowClickExpand: '单击行查看收款单 / 付款单',
    noPhieuThu: '该资金账户暂无收款单。',
    noPhieuChi: '该资金账户暂无付款单。',
    loadError: '无法加载凭证列表。',
    retry: '重试',
    viewAll: '查看全部',
    count: '{count} 张凭证',
  },
}
